import { useEntityTypes } from '../contexts/EntityTypesContext';

/**
 * Simplified entity type interface compatible with ResourceType structure
 * for components that need entity type names
 */
export interface EntityTypeInfo {
    name: string;
    endpoint: string;
    schema: string;
    description?: string;
}

/**
 * Hook to get entity types; driven by tier1 entitlements (no schema entity/attribute calls).
 * Uses EntityTypesContext, which loads from GET /mgmt/Entitlements/entity.
 */
export const useSchemaEntityTypes = () => {
    const { entityTypes, isLoading, error } = useEntityTypes();
    return {
        entityTypes,
        isLoading,
        error
    };
};
